import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
}));

interface SectionTextProps {
  children: any;
  className?: string;
}

export default function SectionText({ children, className }: SectionTextProps) {
  const classes = useStyles();

  return (
    <Typography component="p" className={clsx(classes.text, className)}>
      {children}
    </Typography>
  );
}